import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import CategoryRowItem from './CategoryRowItem';
import { useTranslation } from 'react-i18next';
const SortableCategoryRowItem = ({ item, selected, onSelect, onDelete }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });
    const { i18n } = useTranslation();
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };
    const currentLangCode = i18n.language?.toLowerCase();
    const translation = item.translations?.find(t => t.languageCode?.toLowerCase() === currentLangCode);
    const displayName = translation?.name || item.name;
    return (_jsx(Box, { ref: setNodeRef, style: style, children: _jsx(CategoryRowItem, { name: displayName, questionCount: item.questionCount, selected: selected, onClick: () => onSelect(item.id), onDelete: () => onDelete?.(item.id), dragHandleProps: { ...attributes, ...listeners } }) }));
};
export default SortableCategoryRowItem;
